import React from 'react';
import carlosPhoto from '../assets/team/carlos_3.jpeg';
import naomiePhoto from '../assets/team/naomie_lyse_2.jpeg';
import darixPhoto from '../assets/team/darix.jpeg';
import { useLang } from '../i18n/useLang';

const valueIcons = ['🌍', '⚡', '🎯', '🤝'];

const teamConfig = [
  { initials: 'KN', avClass: 'av-t', photo: carlosPhoto, name: 'Kwame Nkrumah-Asante' },
  { initials: 'ZO', avClass: 'av-v', photo: naomiePhoto, name: 'Zara Okonkwo' },
  { initials: 'AT', avClass: 'av-a', photo: darixPhoto, name: 'Amara Touré' },
  { initials: 'MS', avClass: 'av-c', photo: null, name: 'Mele Sithole' },
  { initials: 'DN', avClass: 'av-g', photo: null, name: 'Dina Ndiaye' },
  { initials: 'BI', avClass: 'av-r', photo: null, name: 'Babajide Ige' },
];

const statValues = ['120+', '14', '30+', '48h'];

const avStyles = {
  'av-t': 'bg-[rgba(20,184,166,0.14)] text-nf-teal',
  'av-v': 'bg-[rgba(109,40,217,0.18)] text-nf-p3',
  'av-a': 'bg-[rgba(245,158,11,0.14)] text-nf-amber',
  'av-c': 'bg-[rgba(6,182,212,0.14)] text-nf-cyan',
  'av-g': 'bg-[rgba(16,185,129,0.14)] text-nf-green',
  'av-r': 'bg-[rgba(244,63,94,0.14)] text-[#fb7185]',
};

const photoBg = {
  'av-t': 'bg-[rgba(20,184,166,0.08)]',
  'av-v': 'bg-[rgba(109,40,217,0.1)]',
  'av-a': 'bg-[rgba(245,158,11,0.08)]',
  'av-c': 'bg-[rgba(6,182,212,0.08)]',
  'av-g': 'bg-[rgba(16,185,129,0.08)]',
  'av-r': 'bg-[rgba(244,63,94,0.08)]',
};

export default function About({ navigate }) {
  const { t } = useLang();
  const values = valueIcons.map((icon, i) => ({ icon, ...t('about.values')[i] }));
  const team = teamConfig.map((cfg, i) => ({ ...cfg, ...t('about.team')[i] }));
  const stats = statValues.map((val, i) => ({ val, lbl: t('about.statsLabels')[i] }));
  return (
    <div>
      {/* Hero */}
      <div className="pt-[72px] sm:pt-[88px] pb-8 lg:pb-12 px-4 sm:px-8 lg:px-20 relative overflow-hidden bg-gradient-to-br from-nf-bg to-nf-bg2">
        <div className="absolute -top-[100px] left-1/2 -translate-x-1/2 w-[900px] h-[600px] bg-[radial-gradient(ellipse,rgba(109,40,217,0.1),transparent_70%)] pointer-events-none" />
        <div className="max-w-[1100px] mx-auto">
          <span className="sec-label">{t('about.secLabel')}</span>
          <h1 className="font-heading font-black leading-none tracking-[-0.03em] max-w-[820px] mb-4"
            style={{ fontSize: 'clamp(26px, 3.6vw, 50px)' }}>
            {t('about.h1')[0]}<span className="text-nf-p3">{t('about.h1')[1]}</span>{t('about.h1')[2]}
          </h1>
          <p className="text-[15px] text-nf-t2 max-w-[680px] leading-[1.75]">{t('about.heroBody')}</p>
        </div>
      </div>

      {/* Stats */}
      <div className="border-t border-b border-white/[0.06]">
        <div className="max-w-[1100px] mx-auto grid grid-cols-2 sm:grid-cols-4">
          {stats.map((s, i) => (
            <div key={s.val} className={`py-[28px] px-6 text-center ${i < stats.length - 1 ? 'border-r border-white/[0.06]' : ''}`}>
              <div className="font-heading text-[34px] font-black tracking-[-0.04em] mb-1.5 bg-gradient-to-br from-nf-text to-nf-acc bg-clip-text text-transparent">{s.val}</div>
              <div className="text-sm text-nf-t2">{s.lbl}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Mission */}
      <div className="py-16 lg:py-24 px-4 sm:px-8 lg:px-20">
        <div className="max-w-[1100px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-[60px] items-center">
          <div>
            <h2 className="font-heading font-black leading-[1.1] tracking-[-0.025em] mb-4"
              style={{ fontSize: 'clamp(20px, 2.8vw, 34px)' }}>
              {t('about.missionTitle')[0]}<span className="text-nf-teal">{t('about.missionTitle')[1]}</span>
            </h2>
            <p className="text-base text-nf-t2 leading-[1.8] mb-4">{t('about.missionBody')[0]}</p>
            <p className="text-base text-nf-t2 leading-[1.8] mb-4">{t('about.missionBody')[1]}</p>
            <p className="text-base text-nf-t2 leading-[1.8] mb-4">{t('about.missionBody')[2]}</p>
            <button className="btn-cta btn-lg mt-8" onClick={() => navigate('services')}>{t('about.missionBtn')}</button>
          </div>
          <div className="flex flex-col gap-4">
            {values.map(v => (
              <div key={v.title} className="flex items-start gap-4 bg-nf-bg2 border border-white/[0.06] rounded-[14px] px-[22px] py-5 transition-colors hover:border-[rgba(109,40,217,0.22)]">
                <span className="text-2xl shrink-0 mt-0.5">{v.icon}</span>
                <div>
                  <h4 className="font-heading text-[15px] font-extrabold mb-1">{v.title}</h4>
                  <p className="text-[13px] text-nf-t2 leading-[1.6] m-0">{v.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Team */}
      <div className="bg-nf-bg2 py-16 lg:py-24 px-4 sm:px-8 lg:px-20">
        <div className="max-w-[1100px] mx-auto">
          <span className="sec-label">{t('about.teamLabel')}</span>
          <h2 className="sec-title">{t('about.teamTitle')}</h2>
          <p className="sec-sub">{t('about.teamSub')}</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-10 lg:mt-14">
            {team.map(m => (
              <div key={m.initials} className="group bg-nf-bg border border-white/[0.06] rounded-[18px] overflow-hidden flex flex-col transition-all duration-300 hover:border-[rgba(109,40,217,0.22)] hover:-translate-y-1">
                {/* Photo frame */}
                {m.photo ? (
                  <div className="w-full h-[400px] overflow-hidden shrink-0">
                    <img src={m.photo} alt={m.name} className="w-full h-full object-cover object-top" />
                  </div>
                ) : (
                  <div className={`w-full h-[150px] shrink-0 flex flex-col items-center justify-center gap-1.5 border-b border-dashed border-[rgba(109,40,217,0.22)] opacity-65 group-hover:opacity-90 transition-opacity ${photoBg[m.avClass]}`}>
                    <span className="text-[28px]">📷</span>
                    <span className="text-[11px] text-nf-t2 font-semibold tracking-[0.06em] uppercase">Photo</span>
                  </div>
                )}
                {/* Text content */}
                <div className="px-[22px] py-6 text-center flex flex-col flex-1">
                  {/* Avatar — only when no photo */}
                  {!m.photo && (
                    <div className={`w-[72px] h-[72px] rounded-full mx-auto mb-4 flex items-center justify-center font-heading text-2xl font-black border border-[rgba(109,40,217,0.22)] ${avStyles[m.avClass]}`}>
                      {m.initials}
                    </div>
                  )}
                  <div className="font-heading text-base font-extrabold mb-1">{m.name}</div>
                  <div className="text-xs text-nf-acc mb-2.5 font-medium">{m.role}</div>
                  <div className="text-xs text-nf-t2 leading-[1.6] mb-3.5">{m.bio}</div>
                  <div className="flex flex-wrap justify-center gap-[5px] mt-auto">
                    {m.tags.map(t => <span key={t} className="chip">{t}</span>)}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA */}
      <div className="py-16 lg:py-[120px] px-4 sm:px-8 lg:px-20 text-center relative overflow-hidden bg-nf-bg">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_55%_65%_at_50%_50%,rgba(109,40,217,0.14),transparent_70%)] pointer-events-none" />
        <div className="relative max-w-[1100px] mx-auto">
          <h2 className="font-heading font-black leading-[1.05] tracking-[-0.03em] max-w-[740px] mx-auto mb-5"
            style={{ fontSize: 'clamp(30px, 4.5vw, 58px)' }}>
            {t('about.ctaHeading')[0]}<span className="text-nf-p3">{t('about.ctaHeading')[1]}</span>
          </h2>
          <p className="text-[17px] text-nf-t2 max-w-[500px] mx-auto mb-11">{t('about.ctaBody')}</p>
          <div className="flex flex-col sm:flex-row gap-3.5 justify-center">
            <a href="https://cal.com/willy-carlos-tchuitcheu-lz7ww7/15min?overlayCalendar=true" target="_blank" rel="noopener noreferrer" className="btn-cta btn-lg w-full sm:w-auto text-center no-underline">{t('about.ctaBtnPrimary')}</a>
            <button className="btn-outline w-full sm:w-auto" onClick={() => navigate('learn')}>{t('about.ctaBtnSecondary')}</button>
          </div>
        </div>
      </div>
    </div>
  );
}
